// omc-frontend/src/hooks/useIsMobile.js
// Hook réutilisable pour détecter les petits écrans (< 640px par défaut)
// Usage : const isMobile = useIsMobile();

import { useState, useEffect } from 'react';

export function useIsMobile(breakpoint = 640) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', handler);
    // Appel immédiat pour éviter un flash au premier rendu
    handler();
    return () => window.removeEventListener('resize', handler);
  }, [breakpoint]);

  return isMobile;
}
